import {Injectable} from '@angular/core';
import {DataCoreService, DlistDto} from '@dabnet-kamu/libs/ui';
import {BehaviorSubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class TemHarcamaService {
  public period!: number;
  kurumsalKod: string;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {
  }


  setParams(period: number, kurumsalKod: string,isReadOnly:boolean, isBindCheck:boolean) {
    this.period = period;
    this.kurumsalKod = kurumsalKod;
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  getData(code: number,control:any, period: number,kurumsalKod?:string, baseEntity?: string, isSetData?: boolean, codeField?:any) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
      if (kurumsalKod) filterArr.push(['KurumsalKod', '=', kurumsalKod]);
      if (period) filterArr.push(['Donem', '=', period]);
    }
    if (code) filterArr.push([codeField, '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
